import { render, staticRenderFns } from "./06_Holzrestaurierung.vue?vue&type=template&id=40e6a26c&"
import script from "./06_Holzrestaurierung.vue?vue&type=script&lang=js&"
export * from "./06_Holzrestaurierung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports